import { api_fetch, api_fetch_throws } from "./client"

export interface BrandFile {
  id: string
  org_id: string
  s3_uri: string
  name: string
  content_type: string
  file_source: string
  created_at: string
  updated_at: string
  actor_name?: string
  metadata?: any
}

export async function uploadBrandFiles(fileSource: string, files: File[]): Promise<BrandFile[]> {
  if (files.length === 0) return []

  const formData = new FormData()
  for (const file of files) {
    formData.append("files", file)
  }

  try {
    const response = await fetch(`/api/brand-files?source=${encodeURIComponent(fileSource)}`, {
      method: "POST",
      credentials: "same-origin",
      body: formData,
    })

    if (!response.ok) {
      const errorText = await response.text()
      let errorMessage = "Upload failed"
      try {
        const errorData = JSON.parse(errorText)
        errorMessage = errorData.message || errorMessage
      } catch (e) {
        errorMessage = errorText || errorMessage
      }
      throw new Error(errorMessage)
    }

    const data = await response.json()
    return data.data || data
  } catch (error) {
    console.error("Error uploading files:", error)
    throw error
  }
}

export async function listBrandFiles(fileSource: string): Promise<BrandFile[]> {
  try {
    const res = await api_fetch<BrandFile[]>(`/brand-files?source=${encodeURIComponent(fileSource)}`)
    if (res.ok) {
      const files = res.value.data
      return Array.isArray(files) ? files : []
    }
    return []
  } catch (error) {
    console.error("Error listing files:", error)
    return []
  }
}

export async function deleteBrandFile(fileId: string): Promise<void> {
  await api_fetch_throws(`/brand-files/${fileId}`, {
    method: "DELETE",
  })
}

